import { wbFetch } from "./wbFetch";

let cache: Map<string, string> | null = null;
let inflight: Promise<Map<string, string>> | null = null;

const normalize = (raw: string): string =>
  raw
    .toLowerCase()
    .replace(/ё/g, "е")
    .replace(/\s+/g, " ")
    .trim();

const loadFromWb = async (): Promise<Map<string, string>> => {
  const response = await wbFetch(
    "https://content-api.wildberries.ru/content/v2/directory/colors?locale=ru",
    "GET",
  );
  const list = (response?.data ?? []) as Array<{ name?: string }>;
  const map = new Map<string, string>();
  for (const item of list) {
    if (item?.name && typeof item.name === "string") {
      map.set(normalize(item.name), item.name);
    }
  }
  return map;
};

export const getWbColorsMap = async (): Promise<Map<string, string>> => {
  if (cache) return cache;
  if (!inflight) {
    inflight = loadFromWb()
      .then((m) => {
        cache = m;
        return m;
      })
      .finally(() => {
        inflight = null;
      });
  }
  return inflight;
};

export const sanitizeColorAgainstWbDictionary = (
  raw: string,
  dictionary: Map<string, string>,
): string[] => {
  if (!raw || dictionary.size === 0) return [];

  const cleaned = raw
    .replace(/\([^)]*\)/g, " ")
    .replace(/[,/|]/g, ";")
    .replace(/\s+и\s+/giu, ";")
    .replace(/\s+с\s+/giu, ";");

  const parts = cleaned
    .split(";")
    .map((part) => normalize(part))
    .filter((part) => part.length > 0);

  const result: string[] = [];
  const seen = new Set<string>();
  for (const part of parts) {
    const exact = dictionary.get(part);
    if (exact && !seen.has(exact)) {
      result.push(exact);
      seen.add(exact);
    }
  }
  return result;
};

export const __resetWbColorsCacheForTests = (): void => {
  cache = null;
  inflight = null;
};
